// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { sortBy } from 'lodash';
import MetadataField from './metadata-field';

const User = {
  id: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  fullName: PropTypes.string,
  email: PropTypes.string,
};

export default class AssignmentField extends MetadataField {
  static propTypes = {
    ...MetadataField.propTypes,
    onAssignmentChange: PropTypes.func.isRequired,
    editing: PropTypes.bool.isRequired,
    assignedToID: PropTypes.string,
    formMembers: PropTypes.arrayOf(PropTypes.shape(User)).isRequired,
  };

  renderEditable() {
    const { styles } = AssignmentField;

    return (
      <select
        value={this.selectValue}
        onChange={this.handleSelectChange}
        className={css(styles.select)}
      >
        {this.renderOptions()}
      </select>
    );
  }

  get selectValue() {
    const { assignedToID } = this.props;

    return assignedToID || '';
  }

  renderLabelContent() {
    return <strong className={MetadataField.styles.strong}>Assigned</strong>;
  }

  renderValueContent() {
    return <span>{this.assignedLabel}</span>;
  }

  renderOptions() {
    const options = [];

    options.push({ value: '', label: '- No Assignment -' });

    const users = sortBy(this.props.formMembers, 'fullName');

    options.push.apply(options, users.map((user) => ({ value: user.id, label: `${user.fullName} (${user.email})` })));

    const result = options.map((option) => (
      <option
        key={option.value}
        value={option.value}
      >
        {option.label}
      </option>
    ));

    return result;
  }

  handleSelectChange = (event) => {
    const userID = event.target.value.length ? event.target.value : null;

    this.props.onAssignmentChange(this.findUser(userID));
  };

  findUser(id) {
    for (const user of this.props.formMembers) {
      if (user.id === id) {
        return user;
      }
    }

    return null;
  }

  get assignedLabel() {
    const { assignedToID } = this.props;
    const user = this.findUser(assignedToID);

    return user ? `${user.fullName} (${user.email})` : null;
  }
}

const styles = cssInJS({
  select: {
    fontFamily: THEME.fontFamily,
    fontSize: THEME.editFontSize,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    display: 'inline-block',
    padding: 5,
    verticalAlign: 'middle',
    borderRadius: 5,
    width: '100%',
    marginTop: 4,
    marginRight: 0,
    marginBottom: 4,
    marginLeft: 0,
    // '-webkit-appearance': 'none',

    '@phone': {
      width: '100%',
    },
  },
});

AssignmentField.styles = styles;
